import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { toast } from '@/hooks/use-toast';
import { whatsappTemplatesApi } from '@/lib/api/whatsapp-templates.api';

import type { CreateWhatsAppTemplateDto } from '@/lib/api/whatsapp-templates.api';

const QUERY_KEY = ['whatsapp-templates'];

export const useWhatsAppTemplates = () =>
  useQuery({ queryKey: QUERY_KEY, queryFn: whatsappTemplatesApi.list });

export const useCreateWhatsAppTemplate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateWhatsAppTemplateDto) => whatsappTemplatesApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QUERY_KEY });
      toast({ variant: 'success', title: 'Template created and submitted to Meta' });
    },
    onError: () => toast({ variant: 'destructive', title: 'Failed to create template' }),
  });
};

export const useSyncWhatsAppTemplates = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => whatsappTemplatesApi.sync(),
    onSuccess: (data) => {
      qc.invalidateQueries({ queryKey: QUERY_KEY });
      toast({ variant: 'success', title: `Synced ${data.count} templates from Meta` });
    },
    onError: () => toast({ variant: 'destructive', title: 'Failed to sync templates' }),
  });
};

export const useDeleteWhatsAppTemplate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => whatsappTemplatesApi.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QUERY_KEY });
      toast({ variant: 'success', title: 'Template deleted' });
    },
    onError: () => toast({ variant: 'destructive', title: 'Failed to delete template' }),
  });
};
